import React from 'react';
import { S2SafeParsable } from 'libs/end-to-end/src/interfaces';
import { useReadFn } from 'apps/sigma2-ui/src/lib/hooks/useReadFn';
import { useReadPattern } from 'apps/sigma2-ui/src/lib/hooks/useReadPattern';

export const useSimpleReadPattern = <TRead,>({
  getUrlFn,
  canRead,
  responseSchema,
}: {
  getUrlFn: () => string | null;
  canRead: boolean;
  responseSchema: S2SafeParsable<unknown, TRead>;
}) => {
  const { isReadyToRead, readFn } = useReadFn({
    getUrlFn,
    canRead,
    responseSchema,
  });

  return useReadPattern({
    isReadyToRead,
    readFn,
  });
};
